"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _InputField = require("./InputField.util");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Form =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Form, _React$Component);

  function Form(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Form);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Form).call(this, _props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createItem", function () {
      var initialValues = (0, _InputField.populateValues)({
        model: _this.props.model
      });
      var _this$state = _this.state,
          valuesList = _this$state.valuesList,
          initialValuesList = _this$state.initialValuesList;
      var nextValuesList = (0, _toConsumableArray2["default"])(valuesList);
      var nextInitialValuesList = (0, _toConsumableArray2["default"])(initialValuesList);
      nextValuesList.push(initialValues);
      nextInitialValuesList.push(initialValues);

      _this.setState({
        valuesList: nextValuesList,
        initialValuesList: nextInitialValuesList
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_removeItem", function (itemIdx) {
      var _this$state2 = _this.state,
          valuesList = _this$state2.valuesList,
          initialValuesList = _this$state2.initialValuesList;
      var nextValuesList = (0, _toConsumableArray2["default"])(valuesList);
      var nextInitialValuesList = (0, _toConsumableArray2["default"])(initialValuesList);
      nextValuesList.splice(itemIdx, 1);
      nextInitialValuesList.splice(itemIdx, 1);

      _this.setState({
        valuesList: nextValuesList,
        initialValuesList: nextInitialValuesList
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_calcInitialState", function (props) {
      var instanceList = [],
          valuesList = [],
          initialValuesList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = props.instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;
          instanceList.push(i);
          var initialValues = (0, _InputField.populateValues)({
            model: props.model,
            instance: i
          });
          initialValuesList.push(initialValues);
          valuesList.push(initialValues);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        instanceList: instanceList,
        initialValuesList: initialValuesList,
        valuesList: valuesList
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderFields", function (_ref) {
      var itemValues = _ref.itemValues,
          itemIdx = _ref.itemIdx;
      var _this$props = _this.props,
          model = _this$props.model,
          FieldComp = _this$props.FieldComp,
          fieldClassName = _this$props.fieldClassName,
          customOnChange = _this$props.onChange;
      var valuesList = _this.state.valuesList;
      return model.fields.map(function (field) {
        var props = {
          key: field.name,
          field: field,
          values: itemValues,
          value: itemValues[field.name],
          onChange: function () {
            var _onChange = (0, _asyncToGenerator2["default"])(
            /*#__PURE__*/
            _regenerator["default"].mark(function _callee(e, value) {
              var result, nextItemValues, nextValuesList;
              return _regenerator["default"].wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(typeof customOnChange === "function")) {
                        _context.next = 14;
                        break;
                      }

                      _context.prev = 1;
                      result = customOnChange({
                        e: e,
                        field: field,
                        value: value,
                        values: itemValues,
                        setState: _this.setState.bind((0, _assertThisInitialized2["default"])(_this)),
                        // this setState refer to ALL state of Multiform
                        setItemValues: function setItemValues(values) {
                          var nextValuesList = (0, _toConsumableArray2["default"])(valuesList);
                          nextValuesList[itemIdx] = values;

                          _this.setState({
                            valuesList: nextValuesList
                          });
                        }
                      });

                      if (!(result && result.then)) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 6;
                      return result;

                    case 6:
                      result = _context.sent;

                    case 7:
                      if (!(result === true)) {
                        _context.next = 9;
                        break;
                      }

                      return _context.abrupt("return");

                    case 9:
                      _context.next = 14;
                      break;

                    case 11:
                      _context.prev = 11;
                      _context.t0 = _context["catch"](1);
                      console.warn("rev-cms-core:Form:_renderFields", _context.t0);

                    case 14:
                      nextItemValues = _objectSpread({}, itemValues, (0, _defineProperty2["default"])({}, field.name, value));
                      nextValuesList = (0, _toConsumableArray2["default"])(valuesList);
                      nextValuesList[itemIdx] = nextItemValues;

                      _this.setState({
                        valuesList: nextValuesList
                      });

                    case 18:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[1, 11]]);
            }));

            function onChange(_x, _x2) {
              return _onChange.apply(this, arguments);
            }

            return onChange;
          }(),
          fieldClassName: fieldClassName
        };

        if (typeof field.widget === "function") {
          return _react["default"].createElement(field.widget, props);
        }

        return _react["default"].createElement(FieldComp, props);
      });
    });
    _this.state = _this._calcInitialState(_props);
    return _this;
  }

  (0, _createClass2["default"])(Form, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.instances !== this.props.instances) {
        this.setState(this._calcInitialState(this.props));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          valuesList = _this$state3.valuesList,
          initialValuesList = _this$state3.initialValuesList;
      return this.props.children({
        valuesList: valuesList,
        renderFields: this._renderFields,
        createItem: this._createItem,
        removeItem: this._removeItem,
        setValueList: function setValueList(valuesList) {
          return _this2.setState({
            valuesList: valuesList
          });
        }
      });
    }
  }]);
  return Form;
}(_react["default"].Component);

var _default = Form;
exports["default"] = _default;